import React, { useState, useRef, useEffect, RefObject } from 'react';
import classNames from 'classnames/bind';
import useOnClickOutside from 'common/hooks/useOnClickOutside';
import styles from './FormSelect.module.scss';

type Props = {
  value: any;
  options: any[];
  placeholder?: string;
  width?: string;
  onChange: (value: any) => void;
  indicateError?: boolean;
  name?: string;
  onBlur?: (e: any) => void;
};

const cx = classNames.bind(styles);

const FormSelect = ({
  value,
  options,
  placeholder,
  width,
  onChange,
  indicateError,
  name,
  onBlur
}: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const handleChange = (selected: any) => {
    setIsOpen(false);
    onChange(selected);
  };
  const registerRef = useRef(null);

  const handleClickOutside = () => {
    setIsOpen(false);
  };

  useOnClickOutside(registerRef, handleClickOutside);

  const wrapperStyle = cx({
    wrapper: true,
    isOpen: isOpen,
  });

  return (
    <div
      ref={registerRef}
      className={wrapperStyle}
      style={{ width: `${width}` }}
      onClick={() => setIsOpen(!isOpen)}
    >
      <input
        type="text"
        className={styles.input + ' ' + (indicateError ? styles.haserror : '')}
        value={value}
        placeholder={placeholder}
        readOnly
        name={name}
        onBlur={onBlur}
      />
      {isOpen && (
        <ul className={styles.dropdown}>
          {(options || []).map((option) => {
            return (
              <li
                className={styles.option}
                onClick={() => handleChange(option)}
              >
                {option}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default FormSelect;
